const socials = [
    {
      id: 1,
      title: 'LinkedIn',
      description: 'My LinkedIn, for business networking.',
      imageURL: '/images/LinkedInIconB.webp',
      URL: 'https://www.linkedin.com/in/darragh-nolan-639125164',
      // Add more project details as needed
    },
    {
        id: 2,
        title: 'Artstation',
        description: 'My Artstation, where I have all of my art projects.',
        imageURL: '/images/ArtstationIconB.webp',
        URL: 'https://www.artstation.com/dazariath',
        // Add more project details as needed
    },
    {
        id: 3,
        title: 'Sketchfab',
        description: 'My Sketchfab, for showcasing my 3D skills.',
        imageURL: '/images/SketchfabIconB.webp',
        URL: 'https://sketchfab.com/Dazariath',
        // Add more project details as needed
    },
    {
        id: 4,
        title: 'Itch.io',
        description: 'Itch.io is an indie games website where I have some published games.',
        imageURL: '/images/ItchioIconB.webp',
        URL: 'https://dazariath.itch.io/',
        // Add more project details as needed
    },
  ];
  
  export default socials;